module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Published in 1987 by")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Academy Chicago Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("425 North Michigan Avenue")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Chicago, Illinois 60611")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Copyright © Leo Bruce 1958")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Printed and bound in the USA")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("No part of this book may be reproduced"), _c('br'), _vm._v("in any form without the express written"), _c('br'), _vm._v("permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Bruce, Leo, 1903-1980.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright4"
  }, [_vm._v("Dead man’s shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright5"
  }, [_vm._v("I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright6"
  }, [_vm._v("PR6005.R673D37    1987      823’.912      87-19370")]), _vm._v(" "), _c('p', {
    staticClass: "copyright6"
  }, [_vm._v("ISBN 0-89733-272-5")]), _vm._v(" "), _c('p', {
    staticClass: "copyright6"
  }, [_vm._v("ISBN 0-89733-271-7 (pbk.)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90190dd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003_Copyright.vue
// module id = 66
// module chunks = 0